export default {
    noWikiExisting: 'No wiki page found.',
    invalidPage: 'Invalid page name.',
    invalidPageExplanation: 'This page does not exist or has no content yet.',
    initWikiExplanation: 'The contents of the wiki need to be maintained in the cms by the administrator.'
}
